import { Navigate, useLocation } from "react-router";

export function TeamsLegacyRedirect() {
    const { pathname, search, hash } = useLocation();
    const target = `/team${pathname.slice("/teams".length)}`;

    return <Navigate replace to={{ pathname: target, search, hash }} />;
}
